// 简单的状态管理
import { reactive } from 'vue';

// 从localStorage恢复状态
const loadState = () => {
  try {
    const savedState = localStorage.getItem('userState');
    if (savedState) {
      return JSON.parse(savedState);
    }
  } catch (error) {
    console.error('Error loading state from localStorage:', error);
  }
  return {
    user: null,
    isLoggedIn: false
  };
};

// 保存状态到localStorage
const saveState = (state) => {
  try {
    localStorage.setItem('userState', JSON.stringify(state));
  } catch (error) {
    console.error('Error saving state to localStorage:', error);
  } 
};

// 创建响应式状态
const state = reactive(loadState());

// 状态变更函数
const mutations = {
  // 设置用户信息
  setUser(user) {
    state.user = user;
    state.isLoggedIn = true;
    saveState(state);
  },
  // 清除用户信息
  clearUser() {
    state.user = null;
    state.isLoggedIn = false;
    saveState(state);
  }
};

// 操作函数
const actions = {
  // 登录
  login(userInfo) {
    mutations.setUser(userInfo);
  },
  // 登出
  logout() {
    mutations.clearUser();
  }
};

// 导出状态管理对象
const store = {
  state,
  mutations,
  actions
};

export default store;